
/*
* AES加密解密安全工具
* */

import CryptoJS from 'crypto-js/crypto-js'
// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse("1234567890123456");
const IV = CryptoJS.enc.Utf8.parse('1234567890123456');


export default{

  /**
   * AES加密 ：字符串 key iv  返回base64
   */
  Encrypt(params) {
    let key = KEY
    let iv = IV
    let srcs = CryptoJS.enc.Utf8.parse(params);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
    // console.log("-=-=-=-", encrypted.ciphertext)
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  },
  /**
   * AES 解密 ：字符串 key iv  返回base64
   *
   */
  Decrypt(params) {
    let key  = KEY
    let iv = IV
    let base64 = CryptoJS.enc.Base64.parse(params);
    let src = CryptoJS.enc.Base64.stringify(base64);
    var decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
   // alert(decrypt)
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  }
}





// WEBPACK FOOTER //
// ./src/utils/AES.js